const calendarId = "melissalbraswell@gmail.com";
const apiKey = "AIzaSyCGA0pPd7mWvrlNZFzatkWqdcfcYVmfqd0";

export default async function getCalendarEvents() {
  try {
    const allEvents = [];
    let pageToken = null;

    do {
      const queryParams = new URLSearchParams({
        key: apiKey,
        ...(pageToken ? { pageToken } : {}),
      });

      const res = await fetch(
        `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?${queryParams.toString()}`,
      );
      const data = await res.json();

      if (!data.items) {
        return allEvents;
      }

      allEvents.push(...data.items);
      pageToken = data.nextPageToken || null;
    } while (pageToken);

    return allEvents;
  } catch (error) {
    console.log(error);
    return [];
  }
}
